import { render } from "./NotificationToast.vue?vue&type=template&id=88b59028&scoped=true&ts=true"
import script from "./NotificationToast.vue?vue&type=script&lang=ts"
export * from "./NotificationToast.vue?vue&type=script&lang=ts"

import "./NotificationToast.vue?vue&type=style&index=0&id=88b59028&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b59028"]])

export default __exports__